import { render, staticRenderFns } from "./LessonOverview.vue?vue&type=template&id=23fede0a&scoped=true&"
import script from "./LessonOverview.vue?vue&type=script&lang=ts&"
export * from "./LessonOverview.vue?vue&type=script&lang=ts&"
import style0 from "./LessonOverview.vue?vue&type=style&index=0&id=23fede0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fede0a",
  null
  
)

export default component.exports